import {
	ActionAndOthers,
	ActionKind,
	deselectAllTitle
} from "client_legacy/ndaw/actions";
import { localize } from "client_legacy/ndaw/culture";
import { UserRequestClientModel } from "client/Api/UserRequests/manageUserRequests";
import { UserRequestStatus } from "client/Api/UserRequests/userRequest";

export type ManageUserRequestActionContext = {
	isMobile: boolean;
	selection: readonly UserRequestClientModel[];
};

export type ManageUserRequestsAction = ActionAndOthers<ManageUserRequestActionContext>;

type ContextualActionsHandlers = {
	openHandler: (request: UserRequestClientModel) => void;
	acceptHandler: (requests: readonly UserRequestClientModel[]) => void;
	declineHandler: (requests: readonly UserRequestClientModel[]) => void;
	deleteHandler: (requests: readonly UserRequestClientModel[]) => void;
};

export const OPEN_ACTION_NAME = "open";

export function listContextualActions(
	handlers: ContextualActionsHandlers
): readonly ManageUserRequestsAction[] {
	const {
		openHandler,
		acceptHandler,
		declineHandler,
		deleteHandler
	} = handlers;

	return [
		{
			kind: ActionKind.Regular,
			name: OPEN_ACTION_NAME,
			title: localize("_ViewDetails"),
			canExecute: (c) => c.selection.length === 1,
			execute: (c) => openHandler(c.selection[0]),
			icon: "eye"
		},
		{
			kind: ActionKind.Regular,
			name: "accept",
			title: localize("_Accept"),
			canExecute: (c) => c.selection.length > 0
				&& c.selection.every(x => x.status === UserRequestStatus.Open),
			execute: (c) => acceptHandler(c.selection),
			icon: "check"
		},
		{
			kind: ActionKind.Regular,
			name: "decline",
			title: localize("_Decline"),
			canExecute: (c) => c.selection.length > 0
				&& c.selection.every(x => x.status === UserRequestStatus.Open),
			execute: (c) => declineHandler(c.selection),
			icon: "xmark"
		},
		{
			kind: ActionKind.Regular,
			name: "delete",
			title: localize("_Delete"),
			canExecute: (c) => c.selection.length > 0
				&& c.selection.every(x => x.status !== UserRequestStatus.Open),
			execute: (c) => deleteHandler(c.selection),
			icon: "trash-can"
		}
	];
}

type SelectionActionsHandlers = {
	deselectHandler: () => void;
};

export function getSelectionActions(handlers: SelectionActionsHandlers): readonly ManageUserRequestsAction[] {
	return [
		{
			kind: ActionKind.Regular,
			name: "deselectAll",
			title: (c) => deselectAllTitle(c.selection),
			icon: "circle-xmark",
			canExecute: (c) => c.selection.length > 0,
			execute: () => handlers.deselectHandler()
		},
		{
			kind: ActionKind.Divider,
			name: "deselect-all-divider",
			canExecute: (c) => !c.isMobile
				&& c.selection.length > 0
		}
	];
}